import React, {useState} from 'react';
import styled from 'styled-components';
import {Link} from "react-router-dom";

import {OzContainer, OzLogo, OzButton} from "@ozwol/webui";

const Wrapper = styled.div`
  position: fixed;
  height: 70px;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0.125rem 0.25rem 0 rgba(0,0,0,.075);
  border-bottom: 1px solid #dee2e6;
  z-index: 999;
`;

const Content = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Logo = styled.div`
  height: 18px;
  flex-grow: 0;
  flex-shrink: 1;
  z-index: 5;
  line-height: 0px;
`;

const Menu = styled.div`

  @media (max-width: 991px){
    position: fixed;
    top: 0px;
    left: ${props => props.isOpen ? "0px" : "-100vw"};
    width: 100vw;
    height: 100vh;
    background-color: #ffffff;
    padding-top: 70px;
    transition: all 0.25s ease-in-out;
  }



`;

const Items = styled.div`
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  list-style: none;

  @media (min-width: 992px){
    align-items: center;
  }

  @media (max-width: 991px){

    flex-direction: column;
    text-align: center;
    box-shadow: 0 0.125rem 0.25rem 0 rgba(0,0,0,.075) inset;
    max-height: calc(100vh - 70px);
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

const Item = styled.div`
  padding: 0 12px;
  vertical-align: middle;
  @media (max-width: 991px){
    padding: 12px 0;
  }

  
  @media (max-width: 991px){
    border-bottom: 1px dashed rgba(112, 112, 112, 0.16);
    & a{
      display: block;
      width: 100%;
    }
  }
`;

const MobiIcons = styled.div`
  z-index: 5;
  line-height: 0px;
  display: flex;
  @media (min-width: 992px){
    display: none;
  }
`;
const MobiIcon = styled.div`
  margin-left: 10px;
  cursor: pointer;
`;

const Topbar = ({ lang, items = [], logoLink = null }) => {

  const [isOpen, setOpen] = useState(false);

  return (
    <Wrapper>
      <OzContainer>
        <Content>
          <Logo>
            {logoLink ?
              <Link to={logoLink}><OzLogo height={"100%"} /></Link>
            :
              <OzLogo height={"100%"} />
            }
          </Logo>
          <Menu isOpen={isOpen}>
            <Items>
              {items.map((item, j) =>
                <Item key={j}>
                  {item}
                </Item>
              )}
            </Items>
          </Menu>
          <MobiIcons>
            <Link to={"/"+lang+"/contact-us"}>
              <MobiIcon onClick={() => setOpen(false)}>
                <OzButton noMinWidth variant="push-black"><span className="material-symbols-outlined">mail</span></OzButton>
              </MobiIcon>
            </Link>
            <MobiIcon onClick={() => setOpen(!isOpen)}>
              <OzButton noMinWidth variant="push-black"><span className="material-symbols-outlined">menu</span></OzButton>
            </MobiIcon>
          </MobiIcons>
        </Content>
      </OzContainer>
    </Wrapper>
  )
}

export default Topbar
